var o;!function(o){o.PLATFORM="platform",o.PROJECT="project"}(o||(o={}));export{o as AccessServiceEnum};